// extracted by mini-css-extract-plugin
var _1 = "FinderFileIcons_fileItem__879c5";
var _2 = "FinderFileIcons_folderItem__6288a";
var _3 = "FinderFileIcons_img__e94ab";
export { _1 as "fileItem", _2 as "folderItem", _3 as "img" }
